import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export class NewBrowserTabEntity extends BaseEntityClass {
  constructor() {
    super();
    this.type = "new_browser_tab";
    this.entity_version = 2;
  }
}
